<template name="hres3cu-detail-process">
  <div>
    <div class="box-tab">
      <div id="accordion">
        <div class="panel box-collapse border-color-skin">
          <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES3CUC2']['10'] }}
            </h3>
          </div>
          <div id="details1" class="panel-collapse collapse in tab-detail">
            <div class="panel-body">
              <div class="detail detail-responsive">
                <div class="detail-block">
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRES3CUC2']['20'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color" ><a @click="toggleDetailComplaint()"  data-toggle="modal" data-target="#hres3cu-popup-complaint">{{ indexSelected.numcom }}</a></div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRES3CUC2']['30'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }} </div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRES3CUC2']['40'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ indexSelected.desc_codcomp }}</div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <hrms-table  :columns="detailProcessColumns"
                       :nowLang="nowLang"
                       :data="detailProcess.table"
                       :searchDisp="false"
                       :addEvent="addEvent"
                       :editEvent="editEvent"
                       :saveInlineEvent="callSave"
                       :addBtnDisp="validateStaappr"
                       :editInlineEventBool="validateStaappr"
                       :rowDisableCondition="rowDisableCondition"
                       :saveInlineBtnDisp="validateStaappr"
                       :deleteInlineEventBool="validateStaappr"
                       :deleteInlineBtnDisp="false"/>

          <popup-process :labels="labels"
            :nowLang="nowLang"
            :labelsButton="labelsButton"
            :indexSelected="indexSelected"
            :searchIndex="searchIndex"
            :detailPopupProcess="detailPopupProcess"
            :postHres3cuDetailprocessPopup="postHres3cuDetailprocessPopup"
            :validateStaappr="validateStaappr" />

          <popup-complaint :labels="labels"
            :nowLang="nowLang"
            :detail="detail"
            :labelsButton="labelsButton"
            :indexSelected="indexSelected" />

        </div>
      </div>
      <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-reply"></i>{{ labelsButton['back'] }}</button>
        <input type="hidden" data-toggle="modal" data-target="#hres3cu-detail-process-popup" ref="popupProcessAddBtn" />
      </div>
    </div>


  </div>
</template>

<script>
import popupProcess from 'components/hres3cu/popupProcess'
import popupComplaint from 'components/hres3cu/popupComplaint'

export default {
  name: 'hres3cu-detail-process',
  data () {
    return {
      detailProcessParams: {
        codempid: this.indexSelected.codempid,
        dtecompl: this.indexSelected.dtecompl,
        numcom: this.indexSelected.numcom,
        stacompl: this.indexSelected.stacompl
      },
      eventBtn: ''
    }
  },
  computed: {
    validateStaappr () {
      return (this.indexSelected.stacompl !== 'S')
    }
  },
  methods: {
    pageDetail (event, param) {
      this.eventBtn = event
      switch (event) {
        case 'add':
          this.detailProcessParams.codempid = ''
          this.receivedHres3cuDetailProcessPopupCreate()
          this.$refs.popupProcessAddBtn.click()
          break
        case 'edit':
          let popupParams = {
            codempid: this.indexSelected.codempid,
            dtecompl: this.indexSelected.dtecompl,
            numcom: this.indexSelected.numcom,
            stacompl: this.indexSelected.stacompl,
            dteopert: param.dteopert,
            codopert: param.codopert
          }
          this.setDetailProcessSelected(param)
          this.detailProcessParams.codempid = param.codempid
          this.receivedHres3cuDetailProcessPopup(popupParams)
          this.$refs.popupProcessAddBtn.click()
          break
      }
    },
    addEvent () {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.pageDetail('edit', param)
    },
    callSave (param) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres3cuDetailprocess({ param: param, searchIndex: this.searchIndex, indexSelected: this.indexSelected, dataRowsHasFlg: param, detailProcessParams: this.indexSelected })
        }
      })
    },
    toggleDetailComplaint () {
      let detailParams = {
        numcom: this.indexSelected.numcom
      }
      this.receivedHres3cuDetail(detailParams)
    },
    rowDisableCondition (dataRow) {
      return dataRow.stacompl !== 'S'
    }
  },
  props: [ 'labels',
    'nowLang',
    'labelsButton',
    'detailProcess',
    'detail',
    'toggle',
    'searchIndex',
    'indexSelected',
    'detailProcessColumns',
    'detailPopupProcess',
    'setDetailProcessSelected',
    'postHres3cuDetailprocess',
    'postHres3cuDetailprocessPopup',
    'receivedHres3cuDetailProcessPopupCreate',
    'receivedHres3cuDetailProcessPopup',
    'receivedHres3cuDetail'
  ],
  components: {
    popupProcess,
    popupComplaint
  }
}
</script>



// WEBPACK FOOTER //
// detailProcess.vue?38a19a60